import { render, staticRenderFns } from "./seleccion-tablas.vue?vue&type=template&id=69205323&scoped=true&"
import script from "./seleccion-tablas.component.ts?vue&type=script&lang=ts&"
export * from "./seleccion-tablas.component.ts?vue&type=script&lang=ts&"
import style0 from "./seleccion-tablas.vue?vue&type=style&index=0&id=69205323&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69205323",
  null
  
)

export default component.exports